import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routes/routes";
import FullLayout from "./layouts/full-layout/FullLayout";
import BlankLayout from "./layouts/blank-layout/BlankLayout";
import Loadable from "./layouts/full-layout/loadable/Loadable";
import { useAuth } from "./authentication/AuthProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Permission Guard
import { DashboardGuard } from "./guards/DashboardAuthGuard";
import {
  TimeandAttendanceLunchGuard,
  TimeandAttendanceBusinessGuard,
  TimeandAttendancePersonalBusinessGuard,
  TimeandAttendanceMissingPunchesGuard,
  TimeandAttendanceMyTimePunchesGuard,
  TimeandAttendanceBuildingGuard,
} from "./guards/TimeandAttendanceGuard";
import {
  ExpensePurchaseOrderManageGuard,
  ExpensePurchaseOrderMPCEPOViewerGuard,
  ExpensePurchaseOrderMPCVoteGuard,
  ExpensePurchaseOrderMyEPOGuard,
  ExpensePurchaseOrderSubordinatesGuard,
  ExpensePurchaseOrderApprovalGuard,
} from "./guards/ExpensePurchaseOrderGaurd";
import {
  AttendanceChangeSubmitNewFTOGuard,
  AttendanceChangeApproveFTOGuard,
  AttendanceChangeHRApprovalGuard,
  AttendanceChangeReviewYTDFTOGuard,
  AttendanceChangeAllDepartmentFTOGuard,
  AttendanceChangeFutureDepartmentFTOGuard,
  VisitorGuard,
} from "./guards/AttendanceChangeGuard";
import {
  DocumentManagementAllDocsGuard,
  DocumentManagementNewECNGuard,
  DocumentManagementNewFCDGuard,
  DocumentManagementNewLITGuard,
  DocumentManagementNewSOPGuard,
  DocumentManagementNewWIGuard,
  DocumentManagementApprovalGuard,
} from "./guards/DocumentManagementGuard";

import {
  AdminAddEmployeeGuard,
  AdminEmployeeLimitGuard,
  AdminAppovalDocumentPersonGuard,
  AdminRolesGuard,
  EmployeeViewGourd,
} from "./guards/AdminGuard";
import { EvalutionProcessGuard } from "./guards/EvalutionFormGuard";
import LetsKnowEachotherDetails from "./views/hr-module/lets-know-each-otherDetails/ViewLetsKnowEachotherDetails";
import { ThankyouPage } from "./components/attendance-change/view-fto/ThankyouPage";
import { ThankyouPageForEpo } from "./views/expense-purchase-order/ThankyouPageEPo";
import NewPassword from "./views/authentication/NewPassword";
import Create from "./views/hr-module/pre-recruitment-process/Addquestion/Create";
import { AllQuestion } from "./views/hr-module/pre-recruitment-process/Allquestion/AllQuestion";
import { AddResume } from "./views/hr-module/pre-recruitment-process/AddResume/AddResume";
import AllCandidateCV from "./views/hr-module/pre-recruitment-process/AllCandidateCV/AllCandidateCV";
import { CandidateCVmanageGuard, CandidateCVViewGuard } from "./guards/CandidateCVGuard";
import { QuestionAddGuard, QuestionGetGuard } from "./guards/QuestionGuard";
import CreateVisitor from "./views/attendance-change/Visitor/Create";
import { AllVisitors } from "./views/attendance-change/Visitor/Visitors/AllVisitors";
import { ThankyouPageForVisisotr } from "./views/attendance-change/Visitor/ThankyouPageForVisisotr";
// import { ThankyouPageForCameraRecording } from "./views/Genricinformation/ThankyouPageForCRecording";

import CreateVisitorW from "./views/attendance-change/Visitor/WithoutLogin/CreateVisitorW";
 
import { ThankyouPageForCRecording } from "./views/Genricinformation/ThankyouPageForCRecording";
import { CancellationThankyou } from "./components/attendance-change/view-fto/CancellationThankyou";
// import EmailForTraining from "./views/hr-module/TrainingModule/training/EmailForTraining";

const Login = Loadable(lazy(() => import("./views/authentication/Login")));
const Error = Loadable(lazy(() => import("./views/authentication/Error")));
const UnAuthorized = Loadable(
  lazy(() => import("./views/unAuthorized/UnAuthorized"))
);
const Register = Loadable(
  lazy(() => import("./views/authentication/Register"))
);

const ResetPassword = Loadable(
  lazy(() => import("./views/authentication/ResetPassword"))
);

const ForgotPassword = Loadable(
  lazy(() => import("./views/authentication/ForgotPassword"))
);
const ChangePassword = Loadable(
  lazy(() => import("./views/authentication/ChangePassword"))
);
const Dashboard = Loadable(lazy(() => import("./views/dashboards/Dashboard1")));
const Dashboard2 = Loadable(
  lazy(() => import("./views/dashboards/Dashboard2"))
);
const Dashboard3 = Loadable(
  lazy(() => import("./views/dashboards/Dashboard3"))
);
// TimeAndAttendance
const AttendanceForLunch = Loadable(
  lazy(() => import("./views/time-attendance/lunch/Lunch"))
);
const AttendanceForBusiness = Loadable(
  lazy(() => import("./views/time-attendance/business/Business"))
);
const AttendanceForPersonalBusiness = Loadable(
  lazy(() =>
    import("./views/time-attendance/personal-business/PersonalBusiness")
  )
);
const MissingPunch = Loadable(
  lazy(() =>
    import("./views/time-attendance/my-missing-punches/MissingPunches")
  )
);
const MyTimePunchRecords = Loadable(
  lazy(() => import("./views/time-attendance/my-time-punch-records/Records"))
);
const Building = Loadable(
  lazy(() => import("./views/time-attendance/whos-in-Building/Building"))
);
// EPO
const EPOCreate = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/create-new-epo/CreateForm_New")
  )
);
const EPOEdit = Loadable(
  lazy(() => import("./views/expense-purchase-order/edit-epo/EditForm"))
);
const EPOMPCViewer = Loadable(
  lazy(() => import("./views/expense-purchase-order/mpc-epo-viewer/EPODetail"))
);
const EPOVote = Loadable(
  lazy(() => import("./views/expense-purchase-order/mpc-vote-for-epo/EPOVote"))
);
const EPOMyList = Loadable(
  lazy(() => import("./views/expense-purchase-order/my-epos/EPOList"))
);
const EPOPayment = Loadable(
  lazy(() => import("./views/expense-purchase-order/epo-payment/PaymentEPO"))
);
const EPOSubordinate = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/subordinate-epo/MySubordinate")
  )
);
const EPOApproval = Loadable(
  lazy(() => import("./views/expense-purchase-order/approval-for-epo/Approval"))
);
const EPOView = Loadable(
  lazy(() => import("./components/expense-purchase-order/view-epo/ViewEPO"))
);

//hr
const HRInterview = Loadable(
  lazy(() =>
    import("./views/hr-module/pre-recruitment-process/PreRecruitmentProcess")
  )
);
const AllRecrutiees = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/pre-recruitment-process/pre-recruitee-list/AllRecruitees"
    )
  )
);
//Evalution Form
// const AllEvalutionCandidate = Loadable(
//   lazy(() =>
//     import(
//       "./views/evalutionForm/EvalutionCandidates"
//     )
//   )
// );
const AllEvalutionCandidate = Loadable(
  lazy(() => import("./views/evalutionForm/EvalutionCandidates"))
);
const EvalutionForm = Loadable(
  lazy(() => import("./views/evalutionForm/EvalutionForm"))
);

const WelcomeNewEmployee = Loadable(
  lazy(() =>
    import("./views/hr-module/welcome-new-employee/WelcomeNewEmployee")
  )
);

const EmployeeofTheMonthNomination = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/employee-of-the-month/EmployeeOfTheMonthNomination"
    )
  )
);

const AllNominee = Loadable(
  lazy(() => import("./views/hr-module/employee-of-the-month/AllNominee"))
);
const NomineeById = Loadable(
  lazy(() => import("./views/hr-module/employee-of-the-month/NomineeView"))
);

 

const AllLetsKnowEachOtherDetails = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/lets-know-each-otherDetails/AllLetsKnowEachOtherDetails"
    )
  )
);
const LetsKnowEachOtherDetailsById = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/lets-know-each-otherDetails/ViewLetsKnowEachotherDetails"
    )
  )
);
const AddLetsKnowEachOtherDetails = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/lets-know-each-otherDetails/LetsKnowEachotherDetails"
    )
  )
);



const AddLeaveSheet = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/LeaveSheet"))
);
const AllLeaveSheet = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/LeaveSheetList"))
);
const LeaveSheetById = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/ViewLeaveSheet"))
);

const TrainingSheetForm = Loadable(
  lazy(() =>
    import("./views/hr-module/TrainingModule/training/TrainingSheetForm")
  )
);
const TrainingList = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/training/TrainingList"))
);
const ViewTraining = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/TrainingModule/training/training-vew/TrainingSheetForm"
    )
  )
);
const EmailForTraining = Loadable(
  lazy(() =>
    import("./views/hr-module/TrainingModule/training/EmailForTraining")
  )
);

const CourseList = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/courses/CourseList"))
);
const CourseForm = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/courses/CourseForm"))
);
const CourseDetailsById = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/courses/ViewCourse"))
);

//FTO
const FTOCreate = Loadable(
  lazy(() => import("./views/attendance-change/new-fto/CreateFTO"))
);
const FTOSchedule = Loadable(
  lazy(() => import("./views/attendance-change/fto-schedule/MyFTO"))
);
const FTOReviewYTD = Loadable(
  lazy(() => import("./views/attendance-change/ytd-fto-status/ReviewYTD"))
);
const FTOApprove = Loadable(
  lazy(() => import("./views/attendance-change/fto-approve/ApproveFTO"))
);
const FTOHrApprove = Loadable(
  lazy(() => import("./views/attendance-change/hr-approval/HrApprove"))
);
const FTOAllMyDept = Loadable(
  lazy(() => import("./views/attendance-change/all-fto-department/ShowAllFTO"))
);
const FTOFutureMyDept = Loadable(
  lazy(() =>
    import("./views/attendance-change/future-fto-department/FutureFTO")
  )
);
const AllCOAMyDept = Loadable(
  lazy(() => import("./views/attendance-change/all-coa-department/COA"))
);
const FutureCOAMyDept = Loadable(
  lazy(() =>
    import("./views/attendance-change/future-coa-department/FutureCOA")
  )
);
const FTOView = Loadable(
  lazy(() => import("./components/attendance-change/view-fto/ViewFTO"))
);
const EmailFTOView = Loadable(
  lazy(() => import("./components/attendance-change/view-fto/EmailViewFto"))
);

//Document Management System
const AllDocuments = Loadable(
  lazy(() => import("./views/document-management/all-document/ListDocument"))
);
const CreateECN = Loadable(
  lazy(() => import("./views/document-management/new-ecn/ECN"))
);
const CreateFCD = Loadable(
  lazy(() => import("./views/document-management/new-fcd/FCD"))
);
const CreateLIT = Loadable(
  lazy(() => import("./views/document-management/new-lit/LIT"))
);
const CreateSOP = Loadable(
  lazy(() => import("./views/document-management/new-sop/SOP"))
);
const CreateWI = Loadable(
  lazy(() => import("./views/document-management/new-wi/WI"))
);
const DocumentView = Loadable(
  lazy(() => import("./views/document-management/view-document/ViewDocument"))
);
const DocumentEdit = Loadable(
  lazy(() => import("./views/document-management/edit-document/EditDocument"))
);

const DocumentApproval = Loadable(
  lazy(() =>
    import("./views/document-management/document-awaiting-approval/Approval")
  )
);

//Admin
const AddEmployee = Loadable(
  lazy(() => import("./views/admin/add-employee/Create"))
);

const EmployeeLimit = Loadable(
  lazy(() => import("./views/admin/emloyee-limit/EmployeeList"))
);

const Approval = Loadable(
  lazy(() => import("./views/admin/approval-document/Approval"))
);

const RoleRights = Loadable(
  lazy(() => import("./views/admin/roles-rights/RolesRights"))
);

// Change Request
const CRCreate = Loadable(
  lazy(() =>
    import("./views/change-request/create-change-request/CreateNewCRForm")
  )
);
const ChangeRequestList = Loadable(
  lazy(() =>
    import("./views/change-request/change-request-list/AllChangeRequests")
  )
);
//Hierarchy
const Hierarchy = Loadable(
  lazy(() =>
    import("./views/Genricinformation/Hierarchy")
  )
);
const PhoneBook = Loadable(
  lazy(() => import("./views/phonebook/PhonebookPage"))
);
 
 
const Hierarchy2 = Loadable(
  lazy(() =>
    import("./views/Genricinformation/Hierarchy2")
  )
);
const PlantLayout = Loadable(
  lazy(() =>
    import("./views/Genricinformation/PlantLayout")
  )
);
const RecordingRequest = Loadable(
  lazy(() =>
    import("./views/Genricinformation/RecordingRequest")
  )
);
const GetAllRecording = Loadable(
  lazy(() =>
    import("./views/Genricinformation/GetAllRecording")
  )
);
const RecordingView = Loadable(
  lazy(() =>
    import("./views/Genricinformation/ViewRecording")
  )
);
const RecordingEdit = Loadable(
  lazy(() =>
    import("./views/Genricinformation/EditRecording")
  )
);
const VisitorDisplay = Loadable(
  lazy(() =>
    import("./views/visitor-display/visitorDisplay")
  )
);
const LunchPassDisplay = Loadable(
  lazy(() =>
    import("./views/visitor-display/LunchPassDisplay")
  )
);
const MonthlySchedule= Loadable(
  lazy(() => import("./views/monthlySchedule/monthlySchedule"))
);

const Holiday = Loadable(
  lazy(() => import("./views/Holiday/Holiday"))
);
const MaterialPassDisplay = Loadable(
  lazy(() =>
    import("./views/visitor-display/MaterialPass")
  )
);
const AppWrapper = () => {
  let auth = useAuth();
  return (
    <>
      <Routes>
        <Route element={auth?.user ? <FullLayout /> : <BlankLayout />}>
          <Route
            path={routes?.home.match}
            element={auth.user ? <Dashboard /> : <Login />}
          />
          <Route path={routes?.error.match} element={<Error />} />
          <Route path={routes?.unAuthorized.match} element={<UnAuthorized />} />
          <Route
            path={routes?.resetPassword.match}
            element={<ResetPassword />}
          />
          <Route
            path={routes?.forgotPassword.match}
            element={<ForgotPassword />}
          />
          {/* Non Auth Route */}
          <Route path={routes?.login.match} element={<Login />} />
          <Route path={routes?.register.match} element={<Register />} />
          {/* Auth Route */}
          <Route
            path={routes.changePassword.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes?.changePassword.match}
              element={<ChangePassword />}
            />
          </Route>
           <Route >
            <Route path={routes.monthlySchedule.match} element={<MonthlySchedule />} />
          </Route>
           <Route >
            <Route path={routes.Holiday.match} element={<Holiday />} />
          </Route>
           <Route >
            <Route path={routes.phonebook.match} element={<PhoneBook />} />
          </Route>
          
          
          
          <Route
              path={routes?.setNewPassword.match}
              element={<NewPassword />}
            />
          {/* Dashboard */}
          <Route path={routes.dashboard.match} element={<DashboardGuard />}>
            <Route path={routes.dashboard.match} element={<Dashboard />} />
          </Route>
          <Route path={routes.dashboard2.match} element={<DashboardGuard />}>
            <Route path={routes.dashboard2.match} element={<Dashboard2 />} />
          </Route>
          <Route path={routes.dashboard3.match} element={<DashboardGuard />}>
            <Route path={routes.dashboard3.match} element={<Dashboard3 />} />
          </Route>
          {/* Hierarchy */}
           <Route
            path={routes.hierarchy.match}
              
          >
            <Route
              path={routes.hierarchy.match}
              element={<Hierarchy />}
            />
           
          </Route>
           <Route
            path={routes.hierarchy2.match}
              
          >
           <Route
              path={routes.hierarchy2.match}
              element={<Hierarchy2 />}
            />
          
           
           
          </Route>
            <Route
              path={routes.RecordingRequest.match}
              element={<RecordingRequest />}
            />
             <Route
              path={routes.Recordinglist.match}
              element={<GetAllRecording />}
            />
             <Route
              path={routes.RecordingView.match}
              element={<RecordingView />}
            />
             <Route
              path={routes.RecordingEdit.match}
              element={<RecordingEdit />}
            />
            <Route
              path={routes.planylayout.match}
              element={<PlantLayout />}
            />
            <Route
              path={routes.VisitorDisplay.match}
              element={<VisitorDisplay />}
            />
             <Route
              path={routes.LunchPassDisplay.match}
              element={<LunchPassDisplay />}
            />
            <Route
              path={routes.MaterialPassDisplay.match}
              element={<MaterialPassDisplay />}
            />
          {/* TimeAndAttendance */}
          <Route
            path={routes.attendanceForLunch.match}
            element={<TimeandAttendanceLunchGuard />}
          >
            <Route
              path={routes.attendanceForLunch.match}
              element={<AttendanceForLunch />}
            />
          </Route>
          <Route
            path={routes.attendanceForBusiness.match}
            element={<TimeandAttendanceBusinessGuard />}
          >
            <Route
              path={routes.attendanceForBusiness.match}
              element={<AttendanceForBusiness />}
            />
          </Route>
          <Route
            path={routes.attendanceForPersonalBusiness.match}
            element={<TimeandAttendancePersonalBusinessGuard />}
          >
            <Route
              path={routes.attendanceForPersonalBusiness.match}
              element={<AttendanceForPersonalBusiness />}
            />
          </Route>
          <Route
            path={routes.missingPunch.match}
            element={<TimeandAttendanceMissingPunchesGuard />}
          >
            <Route
              path={routes.missingPunch.match}
              element={<MissingPunch />}
            />
          </Route>
          <Route
            path={routes.myTimePunchRecords.match}
            element={<TimeandAttendanceMyTimePunchesGuard />}
          >
            <Route
              path={routes.myTimePunchRecords.match}
              element={<MyTimePunchRecords />}
            />
          </Route>
          <Route
            path={routes.building.match}
            element={<TimeandAttendanceBuildingGuard />}
          >
            <Route path={routes.building.match} element={<Building />} />
          </Route>
          {/* EPO */}
          <Route
            path={routes.epoCreate.match}
            element={<ExpensePurchaseOrderManageGuard />}
          >
            <Route path={routes.epoCreate.match} element={<EPOCreate />} />
          </Route>
          <Route path={routes.epoEdit.match} element={<DashboardGuard />}>
            <Route path={routes.epoEdit.match} element={<EPOEdit />} />
          </Route>
          <Route
            path={routes.epoDetail.match}
            element={<ExpensePurchaseOrderMPCEPOViewerGuard />}
          >
            <Route path={routes.epoDetail.match} element={<EPOMPCViewer />} />
          </Route>
          <Route
            path={routes.epoVote.match}
            element={<ExpensePurchaseOrderMPCVoteGuard />}
          >
            <Route path={routes.epoVote.match} element={<EPOVote />} />
          </Route>
          <Route
            path={routes.epoList.match}
            element={<ExpensePurchaseOrderMyEPOGuard />}
          >
            <Route path={routes.epoList.match} element={<EPOMyList />} />
          </Route>
          <Route path={routes.epoPayment.match} element={<DashboardGuard />}>
            <Route path={routes.epoPayment.match} element={<EPOPayment />} />
          </Route>
          <Route
            path={routes.epoSubordinate.match}
            element={<ExpensePurchaseOrderSubordinatesGuard />}
          >
            <Route
              path={routes.epoSubordinate.match}
              element={<EPOSubordinate />}
            />
          </Route>
          <Route
            path={routes.epoApproval.match}
            element={<ExpensePurchaseOrderApprovalGuard />}
          >
            <Route path={routes.epoApproval.match} element={<EPOApproval />} />
          </Route>
          <Route path={routes.epoView.match} element={<DashboardGuard />}>
            <Route path={routes.epoView.match} element={<EPOView />} />
          </Route>
          <Route 
          path={routes.epoapproval.match}>
            <Route
              path={routes.epoapproval.match}
              element={<ThankyouPageForEpo />}
            />
          </Route>
          {/* Human Resource Management */}
          {/* Evaluytion Form */}
  {/* <Route path={routes.hrInterviewCreate.match} element={<DashboardGuard />}></Route> */}

    <Route path={routes.interviewEvaluationForm.match} element={<EvalutionProcessGuard />}> 
 <Route path={routes.interviewEvaluationForm.match} element={<EvalutionForm/>}>
 </Route> 
 
   <Route path={routes.allEvalutionCandidate.match} element={<AllEvalutionCandidate/>} />
 

 </Route>
          {/* Pre-Recruitment Process */}
          <Route path={routes.hrInterviewCreate.match} element={<DashboardGuard />}>
          <Route
            path={routes.hrInterviewCreate.match}
            element={<HRInterview />}
          />
          </Route>
          <Route path={routes.addQuestion.match} element={<QuestionAddGuard />}>

            <Route
            path={routes.addQuestion.match}
            element={<Create />}
          />
          </Route>
          <Route path={routes.questionView.match} element={<DashboardGuard />}>

           <Route
            path={routes.questionView.match}
            element={<Create />}
          />
          </Route>
          <Route path={routes.editQuestion.match} element={<QuestionAddGuard />}>

            <Route
            path={routes.editQuestion.match}
            element={<Create />}
          />
          </Route>
          <Route path={routes.allQuestionlist.match} element={<QuestionGetGuard />}>
          <Route
            path={routes.allQuestionlist.match}
            element={<AllQuestion />}
          />
          </Route>
          <Route
            path={routes.addCandidateCV.match}
            element={<CandidateCVmanageGuard/>}
            >
          <Route
            path={routes.addCandidateCV.match}
            element={<AddResume />}
          />
          </Route>
          <Route
            path={routes.getCandidateCV.match}
            element={<CandidateCVViewGuard />}
          >
           <Route
            path={routes.getCandidateCV.match}
            element={<AllCandidateCV />}
          />
          </Route>
          <Route path={routes.allRecruitee.match} element={<AllRecrutiees />} />
          <Route
            path={routes.welcomeNewEmpl.match}
            element={<WelcomeNewEmployee />}
          />
          {/* EmployeeofTheMonthNomination */}
          <Route
            path={routes.EmployeeOfTheMonthNomination.match}
            element={<EmployeeofTheMonthNomination />}
          />
          <Route path={routes.editEmployeeOfTheMonthNomination.match}
          element={<EmployeeofTheMonthNomination/>}/>
          <Route path={routes.allNominee.match} element={<AllNominee />} />
          <Route path={routes.nomineeView.match} element={<DashboardGuard />}>
            <Route path={routes.nomineeView.match} element={<NomineeById />} />
          </Route>
          {/* Gate Pass */}
     
          {/* Let's Know Each Other Details */}
          <Route
            path={routes.allLetsKnowEachOtherDetails.match}
            element={<AllLetsKnowEachOtherDetails />}
          />
          <Route
            path={routes.addLetsKnowEachOtherDetails.match}
            element={<AddLetsKnowEachOtherDetails />}
          />
          <Route 
            path={routes.updateLetsKnowEachOtherDetails.match}
            element={<AddLetsKnowEachOtherDetails />}
          />
          <Route
            path={routes.letsKnowEachotherDetailsView.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.letsKnowEachotherDetailsView.match}
              element={<LetsKnowEachotherDetails />}
            />
          </Route>
          {/* TrainingSheetForm */}
          <Route
            path={routes.addTrainingSheetForm.match}
            element={<TrainingSheetForm />}
          />
          {/* TrainingList */}
          <Route
            path={routes.allTrainingList.match}
            element={<TrainingList />}
          />
          <Route path={routes.viewTraining.match} element={<DashboardGuard />}>
            <Route
              path={routes.viewTraining.match}
              element={<ViewTraining />}
            />
          </Route>
          <Route path={routes.editTraining.match} element={<DashboardGuard />}>
            <Route
              path={routes.editTraining.match}
              element={<TrainingSheetForm />}
            />
          </Route>
          <Route
            path={routes.emailForTraining.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.emailForTraining.match}
              element={<EmailForTraining />}
            />
          </Route>
          {/* LeaveSheet */}
          <Route
            path={routes.allLeaveSheet.match}
            element={<AllLeaveSheet />}
          />
          <Route
            path={routes.addLeaveSheet.match}
            element={<AddLeaveSheet />}
          />
          <Route
            path={routes.viewLeaveSheet.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.viewLeaveSheet.match}
              element={<LeaveSheetById />}
            />
          </Route>
          {/* Training By Course */}
          <Route path={routes.allCourseList.match} element={<CourseList />} />
          <Route path={routes.addCourseForm.match} element={<CourseForm />} />
          <Route
            path={routes.viewCourseDetails.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.viewCourseDetails.match}
              element={<CourseDetailsById />}
            />
          </Route>

          {/* Attendance */}
          <Route
            path={routes.ftoCreate.match}
            element={<AttendanceChangeSubmitNewFTOGuard />}
          >
            <Route path={routes.ftoCreate.match} element={<FTOCreate />} />
          </Route>
            <Route path={routes.ftoEdit.match} element={<FTOCreate />} />
          <Route path={routes.ftoList.match} element={<DashboardGuard />}>
            <Route path={routes.ftoList.match} element={<FTOSchedule />} />
          </Route>
          <Route
            path={routes.ftoReviewYTD.match}
            element={<AttendanceChangeReviewYTDFTOGuard />}
          >
            <Route
              path={routes.ftoReviewYTD.match}
              element={<FTOReviewYTD />}
            />
          </Route>
          <Route
            path={routes.ftoApprove.match}
             element={<AttendanceChangeApproveFTOGuard />}
          >
            <Route path={routes.ftoApprove.match} element={<FTOApprove />} />
          </Route>
          <Route
            path={routes.ftoAllDepartment.match}
            element={<AttendanceChangeAllDepartmentFTOGuard />}
          >
            <Route
              path={routes.ftoAllDepartment.match}
              element={<FTOAllMyDept />}
            />
          </Route>
          <Route
            path={routes.ftoFutureDepartment.match}
            element={<AttendanceChangeFutureDepartmentFTOGuard />}
          >
            <Route
              path={routes.ftoFutureDepartment.match}
              element={<FTOFutureMyDept />}
            />
          </Route>
          <Route
            path={routes.addvisitor.match}
            element={<VisitorGuard />}
          >
            <Route
              path={routes.addvisitor.match}
              element={<CreateVisitor />}
            />
          </Route>
          <Route 
          path={routes.addvisitorwithoutlogin.match}>
            <Route
              path={routes.addvisitorwithoutlogin.match}
              element={<CreateVisitorW />}
            />
          </Route>
          <Route
            path={routes.allvisitorlist.match}
            element={<VisitorGuard />}
          >
            <Route
              path={routes.allvisitorlist.match}
              element={<AllVisitors />}
            />
          </Route>
          <Route
            path={routes.visitorView.match}
            element={<VisitorGuard />}
          >
            <Route
              path={routes.visitorView.match}
              element={<CreateVisitor />}
            />
          </Route>
          <Route
            path={routes.editVisitor.match}
            element={<VisitorGuard />}
          >
            <Route
              path={routes.editVisitor.match}
              element={<CreateVisitor />}
            />
          </Route>
          <Route
            path={routes.allCOADepartment.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.allCOADepartment.match}
              element={<AllCOAMyDept />}
            />
          </Route>
          <Route
            path={routes.futureCOADepartment.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.futureCOADepartment.match}
              element={<FutureCOAMyDept />}
            />
          </Route>
          <Route path={routes.viewFTO.match} element={<DashboardGuard />}>
            <Route path={routes.viewFTO.match} element={<FTOView />} />
          </Route>
          <Route
            path={routes.ftoHrApprove.match}
            element={<AttendanceChangeHRApprovalGuard />}
          >
            <Route
              path={routes.ftoHrApprove.match}
              element={<FTOHrApprove />}
            />
          </Route>
          {/* <Route 
          path={routes.emailviewFTO.match}>
            <Route
              path={routes.emailviewFTO.match}
              element={<EmailFTOView />}
            />
          </Route> */}
          <Route 
          path={routes.thankyou.match}>
            <Route
              path={routes.thankyou.match}
              element={<ThankyouPage />}
            />
          </Route>
            <Route 
          path={routes.cancellationthankyou.match}>
            <Route
              path={routes.cancellationthankyou.match}
              element={<CancellationThankyou />}
            />
          </Route>
          <Route 
          path={routes.visitorapproval.match}>
            <Route
              path={routes.visitorapproval.match}
              element={<ThankyouPageForVisisotr />}
            />
          </Route>
           <Route 
          path={routes.camerarecordingapproval.match}>
            <Route
              path={routes.camerarecordingapproval.match}
              element={<ThankyouPageForCRecording />}
            />
          </Route>
          {/* Document Management System */}
          <Route
            path={routes.allDocuments.match}
            element={<DocumentManagementAllDocsGuard />}
          >
            <Route
              path={routes.allDocuments.match}
              element={<AllDocuments />}
            />
          </Route>
          <Route
            path={routes.createECN.match}
            element={<DocumentManagementNewECNGuard />}
          >
            <Route path={routes.createECN.match} element={<CreateECN />} />
          </Route>
          <Route
            path={routes.createFCD.match}
            element={<DocumentManagementNewFCDGuard />}
          >
            <Route path={routes.createFCD.match} element={<CreateFCD />} />
          </Route>
          <Route
            path={routes.createLIT.match}
            element={<DocumentManagementNewLITGuard />}
          >
            <Route path={routes.createLIT.match} element={<CreateLIT />} />
          </Route>
          <Route
            path={routes.createSOP.match}
            element={<DocumentManagementNewSOPGuard />}
          >
            <Route path={routes.createSOP.match} element={<CreateSOP />} />
          </Route>
          <Route
            path={routes.createWI.match}
            element={<DocumentManagementNewWIGuard />}
          >
            <Route path={routes.createWI.match} element={<CreateWI />} />
          </Route>
          <Route path={routes.viewDocument.match} element={<DashboardGuard />}>
            <Route
              path={routes.viewDocument.match}
              element={<DocumentView />}
            />
          </Route>
          <Route path={routes.editDocument.match} element={<DashboardGuard />}>
            <Route
              path={routes.editDocument.match}
              element={<DocumentEdit />}
            />
          </Route>
          <Route
            path={routes.documentMyApproval.match}
            element={<DocumentManagementApprovalGuard />}
          >
            <Route
              path={routes.documentMyApproval.match}
              element={<DocumentApproval />}
            />
          </Route>
          {/* Admin */}
          <Route
            path={routes.addEmployee.match}
            element={<AdminAddEmployeeGuard />}
          >
            <Route path={routes.addEmployee.match} element={<AddEmployee />} />
          </Route>
          <Route
            path={routes.editEmployee.match}
            element={<AdminAddEmployeeGuard />}
          >
            <Route path={routes.editEmployee.match} element={<AddEmployee />} />
          </Route>
          <Route
            path={routes.limitEmployee.match}
            element={<AdminEmployeeLimitGuard />}
          >
            <Route
              path={routes.limitEmployee.match}
              element={<EmployeeLimit />}
            />
          </Route>
          <Route
            path={routes.limitEmployees.match}
            element={<AdminEmployeeLimitGuard />}
          >
            <Route
              path={routes.limitEmployees.match}
              element={<EmployeeLimit />}
            />
          </Route>
          <Route
            path={routes.addemployee.match}
            element={<AdminAddEmployeeGuard />}
          >
            <Route path={routes.addemployee.match} element={<AddEmployee />} />
          </Route>
          <Route
            path={routes.approvalDocument.match}
            element={<AdminAppovalDocumentPersonGuard />}
          >
            <Route
              path={routes.approvalDocument.match}
              element={<Approval />}
            />
          </Route>
          <Route path={routes.roleRights.match} element={<AdminRolesGuard />}>
            <Route path={routes.roleRights.match} element={<RoleRights />} />
          </Route>
          <Route
            path={routes.employeeView.match}
            element={<EmployeeViewGourd />}
          >
            <Route
              path={routes.employeeView.match}
              element={<AddEmployee />}
            ></Route>
          </Route>
          {/* Change Request */}
          <Route
            path={routes.crCreate.match}
            element={<ExpensePurchaseOrderManageGuard />}
          >
            <Route path={routes.crCreate.match} element={<CRCreate />} />
          </Route>

          <Route
            path={routes.allChangeRequest.match}
            element={<DocumentManagementAllDocsGuard />}
          >
            <Route
              path={routes.allChangeRequest.match}
              element={<ChangeRequestList />}
            />
          </Route>

          {/* <Route
            path={routes.allChangeRequest.match}
            element={<ChangeRequestList />}
          /> */}

          <Route path={routes.editCR.match} element={<DashboardGuard />}>
            <Route path={routes.editCR.match} element={<CRCreate />} />
          </Route>
          <Route path={routes.crView.match} element={<DashboardGuard />}>
            <Route path={routes.crView.match} element={<CRCreate />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer hideProgressBar={true} />
    </>
  );
};

export default AppWrapper;
